// src/components/MyteGroupWebsite/Footer.js

import {
  Twitter,
  Youtube,
  Instagram,
  Linkedin,
  Mail,
  MapPin,
} from "lucide-react"

export default function Footer() {
  return (
    <footer className="bg-[#0e1d34] text-white pt-16 pb-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="md:col-span-1">
            <a href="/" className="inline-block mb-4">
              <img src="/LogoFile.png" alt="Myte Group Logo" className="h-10" />
            </a>
            <p className="text-blue-200 mb-4">
              Digital Intelligence Integrators and Trainers empowering businesses to become digitally autonomous.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://x.com/Ahmekal"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Twitter size={20} />
              </a>
              <a
                href="https://www.instagram.com/ahmedmekallach"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.linkedin.com/in/ahmedmekallach/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://www.youtube.com/@AhmedMekallach"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/about" className="text-blue-200 hover:text-white transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="#solutions" className="text-blue-200 hover:text-white transition-colors">
                  Solutions
                </a>
              </li>
              <li>
                <a href="#training" className="text-blue-200 hover:text-white transition-colors">
                  Training
                </a>
              </li>
              <li>
                <a href="#success-stories" className="text-blue-200 hover:text-white transition-colors">
                  Success Stories
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-blue-200 hover:text-white transition-colors">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://mytegroup.com/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="https://mytegroup.com/terms-and-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Terms and Conditions
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div id="contact">
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 text-[#3080c1] mt-0.5 mr-2 flex-shrink-0" />
                <span className="text-blue-200">Myte Group, 7501 Av. M B Jodoin, Anjou, QC H1J 2H9</span>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 text-[#3080c1] mr-2 flex-shrink-0" />
                <a href="mailto:info@mytegroup.ai" className="text-blue-200 hover:text-white transition-colors">
                  info@mytegroup.ai
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Myte Group. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
